export default {

  name: 'baseUrl',
  data() {
    let baseURL = '';
    const api = location.hostname;
    switch (api) {
      case 'localhost':
        baseURL = 'https://10api-stage.hova.co.il/api/';
        // baseURL = 'http://localhost:8000/api/';
        break;
      case '10front-stage.hova.co.il':
        baseURL = 'https://10api-stage.hova.co.il/api/';
        break;
      case '10front.10b.co.il':
        baseURL = 'https://10api.10b.co.il/api/';
        break;
      default:
        baseURL = 'https://10api.hova.co.il/api/';
    }
    return baseURL;
  }
}



